import { useEffect, useState } from "react";
import {Button, Container, Nav, Table} from "react-bootstrap";
import { Pen, PlusCircle, Trash } from "react-bootstrap-icons";
import { apiService } from '../../functions/api-service';
import Swal from 'sweetalert2';
import { Alert } from '../../functions/utils';
import { useContexts } from "../../context/AppContext";
import { Treatment } from "../../type";
import {useNavigate} from "react-router-dom";
import ModalTreatment from "../../components/modalTreatment";

export default function SettingTreatment() {
  const { isLoad, isLoaded } = useContexts();
  const [treatmentList, setTreatmentList] = useState<Array<Treatment>>([]);
  const [search, setSearch] = useState("");
  const filteredItems = treatmentList.filter(
    (item) => (item.name && item.name.toString().includes(search))
  );
  const [openFormTreatment, setOpenFormTreatment] = useState<{
    show: boolean;
    data: Treatment | null;
    saved: boolean
  }>({ show: false, data: null, saved: false });
  const {profile } = useContexts();

  useEffect(() => {
    getTreatmentList().catch(console.error);
    if((profile?.sub !== '0')){
      navigate("/setting")
    }
  }, []);

  useEffect(() => {
    if(openFormTreatment.saved){
      getTreatmentList().catch(console.error);
      setOpenFormTreatment((prev) => ({
        ...prev,
        saved: false,
      }))
    }
}, [openFormTreatment.saved]);

  const getTreatmentList = async () => {
    isLoad();
    setTreatmentList(await apiService.treatmentList({status: '1'}));
    isLoaded();
  };

  const removeTreatment = async (data: Treatment) => {
    await Swal.fire({
      title: `ต้องการลบ ${data.name}`,
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ปิด",
    }).then(async (result) => {
      if (result.isConfirmed && data.id) {
        const res = await apiService.removeTreatment(data.id);
        if (res.success === true) {
          getTreatmentList().then();
        }
        Alert(res.success, res.message);
      }
    });
  };

  const navigate = useNavigate();
  return (
    <Container className={"mw-100"}>
      <Nav variant="tabs" defaultActiveKey="/setting/dept">
        <Nav.Item>
          <Nav.Link onClick={() => navigate("/setting/person")} >Person</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link onClick={() => navigate("/setting/prefix")}  >Prefix</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link  onClick={() => navigate("/setting/dept")}  >Departments</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link className={"active"} onClick={() => navigate("/setting/treatment")}  >Regimen</Nav.Link>
        </Nav.Item>
      </Nav>
      <div>
        <h2>รายการ Regimen</h2>
        <div  className="mb-2">ค้นหาข้อมูลได้จาก รหัส และชื่อ</div>
        <div className="mb-2 row">
          <div className={"col-10"}>
          <input className={"form-control"} type="text" placeholder="ค้นหา.." onChange={(e) => setSearch(e.target.value)} />
          </div>
          <div className={"col-2 d-grid"}>
            <Button variant="success" onClick={() => setOpenFormTreatment({ show: true, data: null, saved: false })}><PlusCircle /> เพิ่มข้อมูล</Button>
          </div>
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>รหัส</th>
              <th>ชื่อ</th>
              <th>แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((r) => (
              <tr>
                <td>{r.code}</td>
                <td>{r.name}</td>
                <td className={"text-center"}>
                  <Button
                    size="sm"
                    onClick={() => setOpenFormTreatment({ show: true, data: r, saved: false })}
                  >
                    <Pen />
                  </Button>{" "}
                  <Button variant="danger" size="sm" onClick={() => removeTreatment(r).then()}>
                    <Trash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ModalTreatment
          show={openFormTreatment.show}
          data={openFormTreatment.data}
          handleClose={() =>
            setOpenFormTreatment((prev) => ({
              ...prev,
              show: false,
            }))
          }
          saved={() =>
            setOpenFormTreatment((prev) => ({
              ...prev,
              saved: true,
            }))}
        />
      </div>
      </Container>
  );
}
